import * as React from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { getAltLanguage } from '@utils/i18n';
import { sendLanguageUpdate, updateClient } from '@services';
import { setLanguage } from '@actions/creators';
import { NavButton, InfoDropdown } from './styles';
import { InfoDropDownButton } from '../../../styles';
import { useClient } from '@context/presentation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { toastNotification } from '@utils/toast';
import { TOAST_TYPES, QUERY_KEYS, UNAVAILABLE_CS_FIRM } from '@constants';

export const ClientInfoDropdown = ({ dispatch }) => {
    const queryClient = useQueryClient();
    const [showClientInfo, setShowClientInfo] = React.useState(false);
    const { id, firstName, lastName, leadId, email, language: preferredLanguage, firm } = useClient();
    const [alternateLanguage, setAlternateLanguage] = React.useState(getAltLanguage(preferredLanguage));
    const { clientQuery } = QUERY_KEYS;
    const allDataIsAvailable = firm !== UNAVAILABLE_CS_FIRM;

    const clientMutation = useMutation(data => updateClient(data), {
        onSuccess: () => {
            queryClient.invalidateQueries(clientQuery);
        }
    });

    const changeLanguage = async (evt) => {
        const { value } = evt.target;

        dispatch(setLanguage(value));
        setAlternateLanguage(getAltLanguage(value));
        
        await sendLanguageUpdate({ language: value });
        clientMutation.mutate({ id, language: value });
    };

    const copyLink = () => {
        const link = `${window.location.origin}/presentation/${leadId}`;

        toastNotification(TOAST_TYPES.success, 'Link copied to clipboard');

        navigator.clipboard.writeText(link);
    };

    return (
        <div style={{position: 'relative'}}>
            <NavButton
                selected={showClientInfo}
                border={false}
                onClick={() => setShowClientInfo(!showClientInfo)}>
                    <span>{firstName} {lastName}</span>
                    <div style={{ paddingLeft: '10px'}}>
                        <FontAwesomeIcon icon={faCaretDown}/>
                    </div>
            </NavButton>
            {
                showClientInfo &&
                    <InfoDropdown>
                        { allDataIsAvailable && <li>{email}</li> }
                        <li>Lead ID: {leadId}</li>
                        <li>
                            <InfoDropDownButton
                                onClick={changeLanguage}
                                value={alternateLanguage}>
                                    {alternateLanguage}
                            </InfoDropDownButton>
                        </li>
                        { allDataIsAvailable && 
                            <li>
                               <InfoDropDownButton
                                   onClick={copyLink}>
                                       Copy link
                               </InfoDropDownButton>
                           </li>
                        }
                    </InfoDropdown>
            }
        </div>
    );
};

export default ClientInfoDropdown;
